import './productionLots.scss'
import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './productionLots.html'

/**
 * Items Report route
 *
 * @namespace routes.ReportProductionLots
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.productionLots.list',
  label: 'REPORT.PRODUCTIONLOTS.TITLE',
  url: '/production-lots',
  component: 'tmrReportProductionLots',
  weight: 18,
  resourceType: 'ProductionLot',
  resourceList: {
    searchParameters: [
      'creationDate.from',
      'creationDate.to',
      'code',
      'place.id',
    ],
  },
  accessControl: ['Resource.list', 'Resource.ProductionLot.list'],
}

/**
 * Component for {@link routes.tmrReportProductionLots ProductionLots Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportProductionLots = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
